(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.administrationTools.name)
    .factory('administrationToolsSvc', ['$http', '$q', function ($http, $q) {

            var getSchoolClusters = function (keycode) {
                console.info('In getSchoolClusters service');
                console.info('Making a call to service');
                var schoolClusters = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.administrationTools.endpoints.administrationToolsEndPoint + "cluster",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    schoolClusters = response.data;
                    deferred.resolve(schoolClusters);
                    console.info('Got the SchoolClusters');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getClusterConfigurations = function (keycode) {
                console.info('In getClusterConfigurations service');
                console.info('Making a call to service');
                var clusterConfigs = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.administrationTools.endpoints.administrationToolsEndPoint + "clusterConfig",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    clusterConfigs = response.data;
                    deferred.resolve(clusterConfigs);
                    console.info('Got the clusterConfigurations');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var saveSchoolClusters = function (keycode,listSchoolClusters) {
                console.info('In Save SchoolClusters service');
                console.info('Making a call to service');
                var schoolClusters = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.administrationTools.endpoints.administrationToolsEndPoint + "cluster",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: listSchoolClusters
                });
                request.then(function (response) {
                    schoolClusters = response.data;
                    deferred.resolve(schoolClusters);
                    console.info('SchoolClusters Saved');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var checkPersonId = function (keycode, personId) {
                console.info('In checkPersonId service');
                console.info('Making a call to service');
                var personInfo = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + "person/" + personId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    personInfo = response.data;
                    deferred.resolve(personInfo);
                    console.info('Got the person Info');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var fixDuplicateAdults = function (keycode,fixDupAdultsObject) {
                console.info('In Fix Duplicated Adults service');
                console.info('Making a call to service');
                var schoolClusters = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + "fixDupAdults",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: fixDupAdultsObject
                });
                request.then(function (response) {
                    schoolClusters = response.data;
                    deferred.resolve(schoolClusters);
                    console.info('Adultes Fixed Successfully');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var reactivateAdults = function (keycode,adult) {
                console.info('In Reactivate Adults service');
                console.info('Making a call to service');
                var reactivateAdult = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.manageSchoolData.endpoints.k12DataEndPoint + "person/reactivateAdult",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: adult
                });
                request.then(function (response) {
                    reactivateAdult = response.data;
                    deferred.resolve(reactivateAdult);
                    console.info('Adult reactivation Success');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
            

            return {
                getSchoolClusters: getSchoolClusters,
                getClusterConfigurations: getClusterConfigurations,
                saveSchoolClusters : saveSchoolClusters,
                checkPersonId: checkPersonId,
                fixDuplicateAdults: fixDuplicateAdults,
                reactivateAdults: reactivateAdults
            };
        }

    ]);
}(angular, schoolwork12));